import React from 'react';
import FieldSelect from './FieldSelect';
import { TILE_LAYERS } from './viz/mapIcons';
import { LAYER_TYPES, defaultLayer } from './layerTypes';
import LayerRow from './LayerRow';

// Map visualization config panel: the fixed, configurable base layer, an
// "add layer" picker, and the editable list of overlay layers. Config shape
// is { baseLayer, layers: [{ id, type, visible, group, options }] }.
export default function MapConfig({ numeric, categorical, allFields, config, setConfig }) {
  const baseLayer = config.baseLayer || 'osm';
  const layers = config.layers || [];
  const patchLayers = (next) => setConfig({ layers: next });

  return (
    <div className="map-config">
      <div className="map-config-base">
        <FieldSelect
          label="Base layer"
          options={BASE_LAYER_OPTIONS}
          value={baseLayer}
          onChange={(v) => setConfig({ baseLayer: v })}
        />
      </div>
      <div className="map-config-add">
        <SelectLayer onChange={(type) => patchLayers([...layers, defaultLayer(type)])} />
      </div>
      <div className="map-config-layers">
        {layers.length === 0 && (
          <div className="map-config-empty">No overlay layers yet — add one above.</div>
        )}
        {layers.map((layer) => (
          <LayerRow
            key={layer.id}
            layer={layer}
            numeric={numeric}
            categorical={categorical}
            allFields={allFields}
            onPatch={(patch) =>
              patchLayers(layers.map((l) => (l.id === layer.id ? { ...l, ...patch } : l)))
            }
            onToggle={() =>
              patchLayers(
                layers.map((l) => (l.id === layer.id ? { ...l, visible: !l.visible } : l))
              )
            }
            onRemove={() => patchLayers(layers.filter((l) => l.id !== layer.id))}
          />
        ))}
      </div>
    </div>
  );
}

// Resetting the select value lets the same option be chosen twice.
function SelectLayer({ onChange }) {
  return (
    <label className="map-config-add-label">
      Add layer
      <select
        onChange={(e) => {
          if (e.target.value) {
            onChange(e.target.value);
            e.target.value = '';
          }
        }}
      >
        <option value="">Add layer…</option>
        {LAYER_TYPES.map((t) => (
          <option key={t.type} value={t.type}>
            {t.label}
          </option>
        ))}
      </select>
    </label>
  );
}

const BASE_LAYER_OPTIONS = Object.keys(TILE_LAYERS).map((k) => ({ key: k, label: k }));
